
import { AgGridReact, CustomCellRendererProps } from "ag-grid-react";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import { themeGrid } from "../../../../../themeGrid";
import { localeText } from "../../../../../localeTextFromGrid";
import { useRef, useState } from "react";
import { IGetLanguagesDto } from "../../../../../@types/curriculum.type";


interface LanguagesGridProps {
  languages: IGetLanguagesDto[];
}

export const LanguageGrid: React.FC<LanguagesGridProps> = ({
  languages
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const gridRef = useRef<AgGridReact<any>>(null);

  function getLevel(levelId: string){
    switch (levelId) {
      case "228d0a4f-46ae-40dc-8117-973452c15f4e":
        return "Básico"
      case "1b608e44-b8aa-4a67-a8a3-055872cb1a16":
        return "Básico a Intermediário"
      case "ee5d3ca4-5a18-450d-9a70-2b806297b4b0":
        return"Intermediário"
      case "c627b9c4-b066-442a-89fe-e2be3effeeff":
        return "Avançado"
      case "e2ea8ad9-5ca0-4221-bd9e-7c074149bc70":
        return "Fluente ou Nativo"
      default:
        return "Básico"
    }
  }

  const columnsDefault: ColDef[] = [
    {
      field: "id",
      headerName: "ID",
      hide: true,
    },
    {
      field: "description",
      headerName: "Idioma",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "levelId",
      headerName: "Proeficiência",
      flex: 1,
      maxWidth: 250,
      cellRenderer: (params:CustomCellRendererProps) => {
        return getLevel(params.value)
      }
    },
  ];

  const [columns, setColumns] = useState(columnsDefault);


  const getDataSource = () => ({
    getRows: async (params: IGetRowsParams) => {
      try {
        const response = languages;

        if(response)
          params.successCallback(
            response,
            response.length
          );
        
      } catch (error) {
        console.log(error);
      }
    }
  });

  return (
    <>
      <AgGridReact
        ref={gridRef}
        theme={themeGrid}
        localeText={localeText}
        loading={loading}
        columnDefs={columns}
        overlayNoRowsTemplate="<span style='color: gray;'>Sem registros encontrados</span>"
        defaultColDef={{
          sortable: false,
          editable: false,
          filter: false,
          floatingFilter: false,
        }}
        suppressCellFocus={true}
        rowStyle={{ cursor: "pointer" }}
        rowModelType="infinite"
        datasource={getDataSource()}
        animateRows={true}
        infiniteInitialRowCount={10}
      />
    </>
  );
};
